
































import { defineComponent, ref } from "@nuxtjs/composition-api";
import { ValidationProvider } from "vee-validate";
import { SfHeading } from "@storefront-ui/vue";
import { isEmpty, join } from "lodash-es";

export default defineComponent({
  name: "MultipleSelect",
  components: {
    SfHeading,
    ValidationProvider,
  },
  props: {
    option: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const inputValue = ref([]);
    const selectOptions = ref(props.option.multiple);
    const changeSelectOption = () => {};
    const formatPrice = (option) => {
      return "$" + option.price.toFixed(2);
    };
    const rules = ref(
      (() => {
        let rules = [];
        if (props.option.required) {
          rules.push("required");
        }
        return isEmpty(rules) ? "" : join(rules, "|");
      })()
    );
    return {
      rules,
      selectOptions,
      inputValue,
      formatPrice,
      changeSelectOption,
    };
  },
});
